import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { toggleAnimation } from 'src/app/shared/animations';
import { AuthService } from 'src/app/auth/services/auth.service';
import { IAuthUser } from 'src/app/interfaces/user.interface';
import { Observable } from 'rxjs';
import { StorageService } from 'src/app/services';

@Component({
    selector: 'lc-user-dropdown',
    templateUrl: './user-dropdown.component.html',
    animations: [toggleAnimation],
})
export class UserDropdownComponent {
    user$: Observable<IAuthUser | null>;

    defaultProfilePicture: string = '/assets/images/defaultProfilePicture.png';

    constructor(
        private auth: AuthService,
        private router: Router,
        private localStorageService: StorageService
    ) {
        // Usar currentUser do AuthService migrado para signals
        this.user$ = this.auth.currentUser;
    }

    logout() {
        this.auth.executarLogout();
        this.localStorageService.clearAll();
        this.router.navigate(['/auth/login']);
    }
}
